import { Component, OnInit } from '@angular/core';
import { AutologinUrlsModel } from 'src/app/models/autologin.model';
import { AuthenticationService } from 'src/app/services/authentication.service';

type ButtonKey = 'document' | 'recover';

@Component({
  selector: 'tx-timed-out',
  templateUrl: './timed-out.component.html',
  styleUrls: ['./timed-out.component.scss'],
})
export class TimedOutComponent implements OnInit {
  public autologinUrls: AutologinUrlsModel;

  public disabledButtons: { [key in ButtonKey]: boolean } = {
    document: false,
    recover: false,
  };

  constructor(private authenticationService: AuthenticationService) {
    this.autologinUrls = {
      documentName: '',
      documentAutologinUrl: '',
      recoverAutologinUrl: '',
    };
  }

  disableButton(buttonKey: ButtonKey): void {
    // Use the defined type for the parameter
    this.disabledButtons[buttonKey] = true;
  }

  ngOnInit(): void {
    const urls = this.authenticationService.getAutologinUrls();
    if (urls) {
      this.autologinUrls = urls;
    } else {
      window.location.href = '/';
    }
  }
}
